export const skillStyle = {
    computer: {
        general: {
            page: {
                marginTop: "3%"
            },
            headerContainer: {
                margin: "0 auto",
                width: "70%"
            },
            header: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            subheader: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "1%"
            },
            container: {
                backgroundColor: "rgb(180, 74, 70)",
                margin: "0 auto",
                width: "70%",
                padding: "1%",
                overflowY: "auto",
                height: "700px"
            }
        },
        entries: {
            html5: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "33.75%"
                }
            },
            css3: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2.5%",
                    marginLeft: "41.75%",
                }
            },
            javascript: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "28%"
                }
            },
            jQuery: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "37%"
                }
            },
            sql: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "41%"
                }
            },
            mongodb: {
                icon: {
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "1.5%",
                    marginLeft: "30%"
                }
            },
            react: {
                icon: {
                    margin: "0 auto",
                    marginLeft: "17%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "32.5%"
                }
            },
            redux: {
                icon: {
                    marginTop: "12%",
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "5%",
                    marginLeft: "35.5%"
                }
            },
            express: {
                icon: {
                    marginTop: "7%",
                    marginLeft: "22%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "15%",
                    marginLeft: "30%"
                }
            },
            canto: {
                icon: {
                    marginTop: "2%",
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "7%",
                    marginLeft: "42%"
                }
            }
        }
    },
    tablet: {
        general: {
            page: {
                marginTop: "3%"
            },
            headerContainer: {
                margin: "0 auto",
                width: "70%"
            },
            header: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            subheader: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "1%"
            },
            container: {
                backgroundColor: "rgb(180, 74, 70)",
                margin: "0 auto",
                width: "70%",
                padding: "1%",
                overflowY: "auto",
                height: "700px"
            }
        },
        entries: {
            html5: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "33%"
                }
            },
            css3: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2.5%",
                    marginLeft: "42%"
                }
            },
            javascript: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "27.5%"
                }
            },
            jQuery: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "38%"
                }
            },
            sql: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "42%"
                }
            },
            mongodb: {
                icon: {
                    marginLeft: "22%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "1.5%",
                    marginLeft: "33%"
                }
            },
            react: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "32%"
                }
            },
            redux: {
                icon: {
                    marginTop: "13.5%",
                    marginLeft: "25%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "38%"
                }
            },
            express: {
                icon: {
                    marginTop: "10.5%",
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "15%",
                    marginLeft: "28%"
                }
            },
            canto: {
                icon: {
                    marginTop: "5%",
                    marginLeft: "25%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "7%",
                    marginLeft: "43.75%"
                }
            }
        }
    },
    mobile: {
        general: {
            page: {
                marginTop: "3%"
            },
            headerContainer: {
                margin: "0 auto",
                width: "70%"
            },
            header: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            subheader: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "1%"
            },
            container: {
                backgroundColor: "rgb(180, 74, 70)",
                margin: "0 auto",
                width: "70%",
                padding: "1%",
                overflowY: "auto",
                height: "700px"
            }
        },
        entries: {
            html5: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "33.5%"
                }
            },
            css3: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2.5%",
                    marginLeft: "42%"
                }
            },
            javascript: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "28%"
                }
            },
            jQuery: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "36%",
                    marginBottom: "4%"
                }
            },
            sql: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "4%",
                    marginLeft: "42%"
                }
            },
            mongodb: {
                icon: {
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "1.5%",
                    marginLeft: "30%"
                }
            },
            react: {
                icon: {
                    margin: "0 auto"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "33%"
                }
            },
            redux: {
                icon: {
                    marginTop: "11.75%",
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "2%",
                    marginLeft: "32%"
                }
            },
            express: {
                icon: {
                    marginTop: "17%",
                    marginLeft: "20%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "15%",
                    marginLeft: "29%"
                }
            },
            canto: {
                icon: {
                    marginTop: "15%",
                    marginLeft: "22%"
                },
                header: {
                    color: "white",
                    fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                    marginTop: "7%",
                    marginLeft: "40%"
                }
            }
        }
    }
};